import { Injectable } from '@angular/core';
import { Month } from 'src/app/models/Month';
import { environment } from './../../../environments/environment';
import { UserService } from 'src/app/shared/services/user.service'
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UtilService {

  private exportLeadsSubject = new BehaviorSubject<boolean>(false);
  exportLeads$ = this.exportLeadsSubject.asObservable();

  constructor(private userService: UserService) { }

  getExportLeads(userId: string): void {
    this.userService.findById(userId).subscribe(user => {
      this.exportLeadsSubject.next(user.leads_export);
    });
  }

  setExportLeads(userId: string, exportLeads: boolean): void {
    this.userService.findById(userId).subscribe(user => {
      user.leads_export = exportLeads;
      this.exportLeadsSubject.next(exportLeads);
    })
  };

  listYearsApp(): number[] {
    const yearList = [];

    for (let year = environment.firstYear; year <= this.getYear(); year++) {
      yearList.push(year);
    }

    return yearList;
  }

  listMonths(): Month[] {
    const result: Month[] = [];
    const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    months.forEach((month, index) => {
      result.push({
        number: index + 1,
        name: month
      })
    });
    return result;
  }

  getDate(): Date {
    return new Date();
  }

  getYear(): number {
    return this.getDate().getFullYear();
  }

  getMonth(): number {
    return this.getDate().getMonth() + 1;
  }

  validateUrl(url: string): boolean {
    const urlPattern = /^(http|https):\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/;
    return !url || urlPattern.test(url);
  }

  serialize(obj: any): string {
    var str = [];
    for (var p in obj) {
      if (obj.hasOwnProperty(p) && obj[p] != null) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
    return str.join("&");
  }

  dateToIso(date: Date = null): string {
    if (!date) {
      return null;
    }

    const year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let day: any = date.getDate();

    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    return `${year}-${month}-${day}`;
  }

  isoToDate(date: string = null): Date {
    if (!date) {
      return null;
    }
    const parts = date.split('-');
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Meses em JavaScript são baseados em zero (0 = janeiro, 1 = fevereiro, etc.)
    const day = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }

  isoToBr(date: string = null): string {
    if (!date) {
      return null;
    }

    return date.split('-').reverse().join('/');
  }
}
